import { render, staticRenderFns } from "./BikeContro.vue?vue&type=template&id=1089d6d8&scoped=true"
import script from "./BikeContro.vue?vue&type=script&lang=js"
export * from "./BikeContro.vue?vue&type=script&lang=js"
import style0 from "./BikeContro.vue?vue&type=style&index=0&id=1089d6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089d6d8",
  null
  
)

export default component.exports